<template>
  <div class="dialog-mask">
    <div class="dialog" @click.stop>
      <a href="javascript:;" class="btn-close" @click="close"></a>
      <h1>设专属价</h1>
      <div class="price-input">
        <div>
          <input type="text" v-model="inputPrice" placeholder="请输入设置的专属价格" @input="inputVal" maxlength="6">
        </div>
        <p class="err-msg">{{tips}}</p>
      </div>
      <a href="javascript:;" class="btn-submit" :class="{'disable': disable}" @click="doSumbit">确定</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'managePriceDialog',
  props: ['products'],
  data() {
    return {
      tips: '',
      disable: true,
      inputPrice: ''
    }
  },
  computed: {
    ...mapGetters(['getUserIdentifyInfo']),
  },
  methods: {
    inputVal(ev) {
      let value = ev.target.value
      // this.inputPrice = value.replace(/[^1-9]{0,1}(\d*(?:\.\d{0,2})?).*$/g, '$1')
      this.inputPrice = value.replace(/[^1-9]{0,1}(\d*).*$/g, '$1')
      if (this.getUserIdentifyInfo.storeInfo) {
        if (this.inputPrice < this.products.limitedPrice) {
          this.tips = `您设置的价格，低于最低限价${this.products.limitedPrice}，是否继续？`
          this.disable = false
        } else if (!this.inputPrice) {
          this.disable = true
        } else {
          this.tips = ''
          this.disable = false
        }
      } else if (this.inputPrice) {
        this.tips = ''
        this.disable = false
      } else {
        this.disable = true
      }
    },
    doSumbit() {
      if (this.disable) return
      this.$emit('submit', this.inputPrice)
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-mask{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  background: rgba(0,0,0,.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog{
  position: relative;
  width: 5.4rem;
  padding: .28rem .38rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: .24rem;
  h1{
    margin-bottom: .64rem;
    text-align: center;
    font-size: .32rem;
    font-weight: 400;
    color: #333;
  }
  input{
    width: 100%;
    font-size: .28rem;
  }
  .price-input{
    > div{
      padding-bottom: .16rem;
      border-bottom: 1px solid #eee;
    }
  }
  .err-msg{
    margin-bottom: .6rem;
    padding: .2rem 0;
    font-size: .2rem;
    color: $themeSynRed;
  }
  .btn-submit{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: .28rem;
    color: #fff;
    height: .88rem;
    border-radius: .44rem;
    background: $themeSynMain;
  }
  .disable{
    opacity: .3;
  }
  .btn-close{
    position: absolute;
    right: .3rem;
    top: .3rem;
    width: .4rem;
    height: .4rem;
    background: url(https://cdn09.ehaier.com/shunguang/H5/www/img/sgmobile/common/control-close.png) no-repeat;
    background-size: cover;
  }
}
</style>
